import { createApp, reactive, provide, inject } from "vue";
import App from "./App.vue";
import rem from "./common/js/rem.js";
// import mqtt from'./common/js/mqtt.js'
import router from "./router";
// import axios from 'axios'

import { createState } from "./store";
import "vant/lib/index.css";
import "./common/css/base.css";
import "./common/iconfont/iconfont.css";
import {
  Col,
  NoticeBar,
  Space,
  Row,
  Collapse,
  CollapseItem,
  Tab,
  Tabs,
  NavBar,
  Swipe,
  SwipeItem,
  Search,
  List,
  Icon,
  Divider,
  Popup,
  ActionBarIcon,
  Button,
  Overlay,
} from "vant";

import ElementUI from "element-plus";
// axios.defaults.baseURL = 'http://www.supershooter.cn:8095'
// axios.defaults.baseURL = 'http://192.168.24.93:56655'
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";


const app = createApp(App);
// app.config.globalProperties.$http =axios

app
  .use(store)
  .use(router)
  .use(ElementPlus, { locale })
  .use(Space)
  .use(NoticeBar)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(List)
  .use(Search)
  .use(Icon)
  .use(NavBar)
  .use(Tab)
  .use(Tabs)
  .use(Collapse)
  .use(CollapseItem)
  .use(Divider)
  .use(Popup)
  .use(Col)
  .use(Row)
  .use(ActionBarIcon)
  .use(Overlay)

  .mount("#app");
